import { useEffect, useRef, useState } from 'react'

import '../../styles/Navbar.css'
const MENU_ITEMS = [
  { label: 'Home', href: '/' },
  {
    label: 'Courses', href: '/course/', children: [
      { label: 'Engineering', href: '/course/engineering/' },
      { label: 'Agriculture', href: '/course/agriculture/' },
      { label: 'Arts & Science', href: '/course/arts-science/' },
      { label: 'Diploma / Polytechnic', href: '/course/diploma/' },
      { label: 'Architecture & Design', href: '/course/architecture-design/' },
      { label: 'Fishery Science', href: '/course/fishery-science/' },
      { label: 'Management & MBA', href: '/course/management-mba/' },
      { label: 'MBBS', href: '/course/mbbs/' },
      { label: 'BDS', href: '/course/bds/' },
      { label: 'Allied Health Science', href: '/course/allied-health-science/' },
      { label: 'Veterinary Science', href: '/course/veterinary-science/' },
      { label: 'Pharmacy', href: '/course/pharmacy/' },
      { label: 'Nursing', href: '/course/nursing/' },
      { label: 'Physiotherapy', href: '/course/physiotherapy/' },
      { label: 'Occupational Therapy', href: '/course/occupational-therapy/' },
      { label: 'Ayurveda', href: '/course/ayurveda/' },
      { label: 'Homeopathy', href: '/course/homeopathy/' },
      { label: 'Unani Medicine', href: '/course/unani/' },
      { label: 'Teacher Education', href: '/course/teacher-education/' },
      { label: 'Marine & Nautical', href: '/course/marine-nautical/' },
      { label: 'Hotel Management', href: '/course/hotel-management/' },
      { label: 'Law (LLB, BA-LLB)', href: '/course/law/' },
      { label: 'Psychology', href: '/course/psychology/' },
      { label: 'Aviation', href: '/course/aviation/' },
      { label: 'Sports & Physical Education', href: '/course/sports-physical-education/' },
      { label: 'Commerce, Finance & Accounting', href: '/course/commerce-finance-accounting/' },
      { label: 'Media, Journalism & Visual Communication', href: '/course/media-journalism-visual-communication/' },
      { label: 'Fine Arts & Performing Arts', href: '/course/fine-arts-performing-arts/' },
    ],
  },
  {
    label: 'Colleges', href: '/colleges/', children: [
      { label: 'Engineering Colleges', href: '/colleges/engineering/' },
      { label: 'Agriculture Colleges', href: '/colleges/agriculture/' },
      { label: 'Arts & Science Colleges', href: '/colleges/arts-science/' },
      { label: 'Diploma Colleges', href: '/colleges/diploma/' },
      { label: 'MBA Colleges', href: '/colleges/management-mba/' },
      { label: 'Pharmacy Colleges', href: '/colleges/pharmacy/' },
      { label: 'Nursing Colleges', href: '/colleges/nursing/' },
      { label: 'Physiotherapy Colleges', href: '/colleges/physiotherapy/' },
      { label: 'Allied Health Science Colleges', href: '/colleges/allied-health-science/' },
      { label: 'Teacher Education Colleges', href: '/colleges/teacher-education/' },
      { label: 'Hotel Management Colleges', href: '/colleges/hotel-management/' },
      { label: 'Ayurveda Colleges', href: '/colleges/ayurveda/' },
      { label: 'Law Colleges', href: '/colleges/law/' },
      { label: 'BDS Colleges', href: '/colleges/bds/' },
      { label: 'Veterinary Science Colleges', href: '/colleges/veterinary/' },
      { label: 'Physical Education Colleges', href: '/colleges/sports/' },
      { label: 'MBBS Colleges', href: '/colleges/mbbs/' },
      { label: 'Fishery Science Colleges', href: '/colleges/fishery/' },
      { label: 'Marine & Nautical Colleges', href: '/colleges/marine/' },
      { label: 'Homeopathy Colleges', href: '/colleges/homeopathy/' },
      { label: 'Architecture & Design Colleges', href: '/colleges/architecture-design/' },
      { label: 'Occupational Therapy Colleges', href: '/colleges/occupational-therapy/' },
      { label: 'Unani Medicine Colleges', href: '/colleges/unani/' },
      { label: 'Psychology Colleges', href: '/colleges/psychology/' },
      { label: 'Media, Journalism & Visual Communication Colleges', href: '/colleges/media-journalism-visual-communication/' },
      { label: 'Fine Arts & Performing Arts Colleges', href: '/colleges/fine-arts-performing-arts/' },
      { label: 'Aviation Colleges', href: '/colleges/aviation/' },
      { label: 'Commerce, Finance & Accounting Colleges', href: '/colleges/commerce-finance-accounting/' },
    ],
  },
  {
    label: 'Services', href: '/services/', children: [
      { label: 'Direct College Admissions', href: '/services/direct-college-admission-india/' },
      { label: 'Online UG / PG Admissions', href: '/services/online-ug-pg-admissions/' },
      { label: 'Distance Education Admissions', href: '/services/distance-education-admissions/' },
      { label: 'Abroad Admissions', href: '/services/abroad-admission/' },
    ],
  },
  {
    label: 'Counselling', href: '/counselling/', children: [
      { label: 'Engineering Counselling (TNEA)', href: '/counselling/engineering-counselling-tnea/' },
      { label: 'Medical Counselling (MBBS / BDS & More)', href: '/counselling/medical-counselling-mbbs-bds-more/' },
      { label: 'Agriculture Counselling', href: '/counselling/agriculture-counselling/' },
      { label: 'MBA & MCA Counselling (TANCET)', href: '/counselling/mba-mca-counselling-tancet/' },
      { label: 'Paramedical Counselling', href: '/counselling/paramedical-counselling/' },
      { label: 'Arts & Science Counselling', href: '/counselling/arts-and-science-counselling/' },
      { label: 'Diploma / Polytechnic Counselling', href: '/counselling/diploma-polytechnic-counselling/' },
      { label: 'Teacher Education Counselling', href: '/counselling/teacher-education-counselling/' },
      { label: 'Law Counselling', href: '/counselling/law-counselling/' },
    ],
  },
  {
    label: 'Entrance Exams', href: '/entrance-exam/', children: [
      { label: 'NEET (UG)', href: '/entrance-exam/neet-entrance-examination-ug/' },
      { label: 'JEE Main', href: '/entrance-exam/jee-main-entrance-examination/' },
      { label: 'GATE', href: '/entrance-exam/gate-entrance-examination/' },
      { label: 'JEE Advanced', href: '/entrance-exam/jee-advanced-entrance-examination/' },
      { label: 'NEET (PG)', href: '/entrance-exam/neet-pg-entrance-examination/' },
      { label: 'TANCET', href: '/entrance-exam/tancet-management-computer-application-entrance-exam/' },
      { label: 'NATA', href: '/entrance-exam/nata-entrance-examination/' },
      { label: 'MAT', href: '/entrance-exam/mat-entrance-examination/' },
      { label: 'CAT', href: '/entrance-exam/cat-entrance-examination/' },
      { label: 'CMAT', href: '/entrance-exam/cmat-entrance-examination/' },
      { label: 'CLAT', href: '/entrance-exam/clat-entrance-examination/' },
      { label: 'LSAT', href: '/entrance-exam/lsat-entrance-examination-lsat-india/' },
      { label: 'UCEED', href: '/entrance-exam/uceed-entrance-examination/' },
      { label: 'CEED', href: '/entrance-exam/ceed-entrance-examination/' },
      { label: 'CUET', href: '/entrance-exam/cuet-entrance-examination-ug/' },
      { label: 'NIFT', href: '/entrance-exam/nift-entrance-examination/' },
      { label: 'AME CET', href: '/entrance-exam/ame-cet/' },
      { label: 'IMU CET', href: '/entrance-exam/imu-cet/' },
      { label: 'AIIMS / JIPMER', href: '/entrance-exam/aiims-jipmer-via-neet/' },
    ],
  },
  {
    label: 'Scholarships', href: '/scholarship/', children: [
      { label: '7.5% Reservation Scheme', href: '/scholarship/7-5-reservation-scheme/' },
      { label: 'Pudhumai Penn Scheme', href: '/scholarship/pudhumai-penn-scheme/' },
      { label: 'Post-Matric Scholarship', href: '/scholarship/post-matric-scholarship/' },
      { label: 'Sports Scholarship', href: '/scholarship/sports-scholarship/' },
      { label: 'First Graduate Scholarship', href: '/scholarship/first-graduate-scholarship/' },
      { label: 'Adi Dravidar & Tribal Welfare Scholarship', href: '/scholarship/adi-dravidar-tribal-welfare-scholarship/' },
      { label: 'Tamizh Pudhalvan Scheme', href: '/scholarship/tamizh-pudhalvan-scheme/' },
      { label: 'BC MBC DNC Scholarship', href: '/scholarship/bc-mbc-dnc-scholarship/' },
      { label: 'Minority Scholarship', href: '/scholarship/minority-scholarship-muslim-christian/' },
      { label: 'AICTE Pragati & Saksham Scholarship', href: '/scholarship/aicte-pragati-saksham-scholarship/' },
      { label: "Chief Minister's Merit Award", href: '/scholarship/chief-ministers-merit-award/' },
      { label: 'Nalavariyam Scholarship Scheme', href: '/scholarship/nalavariyam-scholarship-scheme/' },
      { label: 'Central Sector Scholarship Scheme', href: '/scholarship/central-sector-scholarship-scheme/' },
      { label: 'Single Parent / Orphan Scholarship', href: '/scholarship/single-parent-or-orphan-scholarship/' },
      { label: 'Differently-Abled Scholarship', href: '/scholarship/differently-abled-scholarship/' },
      { label: 'National Means-Cum-Merit Scholarship', href: '/scholarship/national-means-cum-merit-scholarship/' },
      { label: 'Perasiriyar Anbazhagan Teacher Education Scholarship', href: '/scholarship/perasiriyar-anbazhagan-teacher-education-scholarship/' },
    ],
  },
  { label: 'Blog', href: '/blog/' },
  {
    label: 'Our Tools', href: '/tools/', children: [
      { label: 'Career Path Generator', href: '/tools/career-path-generator/' },
      { label: 'Scholarship Finder', href: '/tools/scholarship-finder-tool/' },
      { label: 'Cutoff Calculator', href: '/tools/cut-off-calculator-tool/' },
      { label: 'Skill Recommendation', href: '/tools/skill-recommentation-tool/' },
      // { label: 'Admission Helpline', href: '/tools/admission-helpline/' },
    ],
  },
]


const LOGO_URL = '/assets/collegeshine--logo.webp'


export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [openSubmenu, setOpenSubmenu] = useState(null) // mobile accordion: index of open top-level item
  const [touchActive, setTouchActive] = useState(null) // desktop tap-to-open: index of open item
  const [isPinned, setIsPinned] = useState(false)
  const [navHeight, setNavHeight] = useState(0)
  const wrapperRef = useRef(null)
  const headerTopRef = useRef(null)
  const stickyRef = useRef(null)

  // Lock body scroll while the off-canvas panel is open, close on Escape.
  useEffect(() => {
    document.body.classList.toggle('th-menu-open-lock', mobileOpen)
    function onKey(e) {
      if (e.key === 'Escape') setMobileOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [mobileOpen])

  // Scroll behavior: the contact/social top bar scrolls away, then the
  // main navigation becomes fixed to the viewport. A spacer preserves the
  // document flow so the page never jumps when the nav is pinned.
  useEffect(() => {
    const update = () => {
      const top = headerTopRef.current
      const nav = stickyRef.current
      if (!top || !nav) return
      const threshold = Math.max(1, top.getBoundingClientRect().height - 1)
      const pinned = window.scrollY >= threshold
      setIsPinned((prev) => (prev === pinned ? prev : pinned))
      setNavHeight(nav.offsetHeight || 0)
    }

    update()
    window.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
    }
  }, [])

  // Close the desktop tap-to-open dropdown when clicking anywhere else.
  useEffect(() => {
    function onDocClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setTouchActive(null)
      }
    }
    document.addEventListener('click', onDocClick)
    return () => document.removeEventListener('click', onDocClick)
  }, [])

  function closeMobile() {
    setMobileOpen(false)
  }

  function handleDesktopParentClick(e, index) {
    // Only intercept on touch/coarse-pointer devices (tablets, touch laptops
    // above the 992px breakpoint where the hamburger hasn't taken over yet).
    const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches
    if (!isTouch || window.innerWidth < 992) return // handled by the mobile panel instead

    if (touchActive !== index) {
      e.preventDefault()
      setTouchActive(index)
    }
    // Second tap while already open: let the link navigate normally.
  }

  function toggleMobileSubmenu(index) {
    setOpenSubmenu((prev) => (prev === index ? null : index))
  }

  return (
    <header className="th-header header-layout-default prebuilt" ref={wrapperRef}>
      
      <div className="logo-bg-half" />

      <div className="header-top" ref={headerTopRef}>
        <div className="container-fluid">
          <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
            <div className="col-auto d-none d-lg-block">
              <div className="header-links">
                <ul>
                  <li>
                    <svg
                      className="icon-svg icon-svg-phone"
                      viewBox="0 0 24 24"
                      width="15"
                      height="15"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M6.6 10.8c1.4 2.8 3.7 5.1 6.5 6.5l2.2-2.2c.3-.3.7-.4 1.1-.2 1.2.4 2.5.6 3.8.6.6 0 1 .4 1 1V20.8c0 .6-.4 1-1 1C10.6 21.8 2.2 13.4 2.2 2.8c0-.6.4-1 1-1H7c.6 0 1 .4 1 1 0 1.3.2 2.6.6 3.8.1.4 0 .8-.2 1.1L6.6 10.8z" />
                    </svg>
                    <a href="tel:9865553629,9543854321">98655 53629 , 95438 54321</a>
                  </li>
                  <li className="d-none d-xl-inline-block">
                    <svg
                      className="icon-svg icon-svg-envelope"
                      viewBox="0 0 24 24"
                      width="15"
                      height="15"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M2 5.5C2 4.7 2.7 4 3.5 4h17c.8 0 1.5.7 1.5 1.5v13c0 .8-.7 1.5-1.5 1.5h-17c-.8 0-1.5-.7-1.5-1.5v-13zm2.2.5 7.3 6 7.3-6H4.2zM20 7.9l-7.4 6.1a1 1 0 0 1-1.2 0L4 7.9V18h16V7.9z" />
                    </svg>
                    <a href="mailto:info@collegeshine.com">info@collegeshine.com</a>
                  </li>
                  <li>
                    <a className="admission_enquiry" href="/tools/admission-helpline/">
                      Admission Enquiry
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-auto">
              <div className="header-links header-right">
                <ul>
                  <li>
                    <div className="header-social">
                      <a href="http://facebook.com/collegeshine" aria-label="Facebook">
                        <svg
                          className="icon-svg icon-svg-facebook"
                          viewBox="0 0 24 24"
                          width="15"
                          height="15"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0 0 22 12z" />
                        </svg>
                      </a>
                      <a href="https://www.youtube.com/@collegeshine" aria-label="YouTube">
                        <svg
                          className="icon-svg icon-svg-youtube"
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M23.5 6.2c-.3-1.1-1.1-1.9-2.2-2.2C19.4 3.5 12 3.5 12 3.5s-7.4 0-9.3.5C1.6 4.3.8 5.1.5 6.2 0 8.1 0 12 0 12s0 3.9.5 5.8c.3 1.1 1.1 1.9 2.2 2.2 1.9.5 9.3.5 9.3.5s7.4 0 9.3-.5c1.1-.3 1.9-1.1 2.2-2.2.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z" />
                        </svg>
                      </a>
                      <a href="https://instagram.com/collegeshine" aria-label="Instagram">
                        <svg
                          className="icon-svg icon-svg-instagram"
                          viewBox="0 0 24 24"
                          width="15"
                          height="15"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 2 .2 2.4.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.3 1.2.4 2.4.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 2-.4 2.4-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1.2.3-2.4.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-2-.2-2.4-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.3-1.2-.4-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-2 .4-2.4.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1.2-.3 2.4-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.1 0-3.5 0-4.7.1-1 .1-1.6.2-1.9.3-.5.2-.8.4-1.2.7-.3.3-.6.7-.7 1.2-.1.3-.3.9-.3 1.9-.1 1.2-.1 1.6-.1 4.7s0 3.5.1 4.7c.1 1 .2 1.6.3 1.9.2.5.4.8.7 1.2.3.3.7.6 1.2.7.3.1.9.3 1.9.3 1.2.1 1.6.1 4.7.1s3.5 0 4.7-.1c1-.1 1.6-.2 1.9-.3.5-.2.8-.4 1.2-.7.3-.3.6-.7.7-1.2.1-.3.3-.9.3-1.9.1-1.2.1-1.6.1-4.7s0-3.5-.1-4.7c-.1-1-.2-1.6-.3-1.9-.2-.5-.4-.8-.7-1.2-.3-.3-.7-.6-1.2-.7-.3-.1-.9-.3-1.9-.3-1.2-.1-1.6-.1-4.7-.1zm0 4.3a5.7 5.7 0 1 1 0 11.4 5.7 5.7 0 0 1 0-11.4zm0 1.8a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8zm6-2a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6z" />
                        </svg>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`sticky-wrapper-spacer${isPinned ? ' is-active' : ''}`}
        style={{ height: isPinned ? `${navHeight}px` : 0 }}
        aria-hidden="true"
      />
      <div
        className={`sticky-wrapper${isPinned ? ' js-pinned' : ''}`}
        ref={stickyRef}
      >
        <div className="menu-area">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-auto">
                <div className="row align-items-center justify-content-between">
                  <div className="col-auto">
                    <div className="header-logo">
                      <a className="logo" href="/">
                        <img
                          alt="CollegeShine"
                          className="img-fluid"
                          width="150"
                          height="53"
                          sizes="(max-width: 767px) 125px, 150px"
                          fetchPriority="high"
                          loading="eager"
                          src={LOGO_URL}
                        />
                      </a>
                    </div>
                  </div>

                  <div className="col-auto">
                    <nav className="main-menu hide-icon d-none d-lg-inline-block" aria-label="Primary navigation">
                      <ul id="menu-primary-menu-1">
                        {MENU_ITEMS.map((item, index) => (
                          <li
                            key={item.label}
                            className={item.children ? 'menu-item-has-children' : undefined}
                          >
                            <a
                              href={item.href}
                              aria-current={index === 0 ? 'page' : undefined}
                              onClick={
                                item.children ? (e) => handleDesktopParentClick(e, index) : undefined
                              }
                            >
                              {item.label}
                            </a>
                            {item.children && (
                              <ul className="sub-menu">
                                {item.children.map((child) => (
                                  <li key={child.label}>
                                    <a href={child.href}>{child.label}</a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    </nav>

                    <button
                      className="th-menu-toggle d-block d-lg-none"
                      type="button"
                      aria-label="Open navigation menu"
                      aria-controls="cs-mobile-navigation"
                      aria-expanded={mobileOpen}
                      onClick={() => setMobileOpen(true)}
                    >
                      <svg
                        className="icon-svg icon-svg-bars"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <rect x="2" y="5" width="20" height="2.4" rx="1.2" />
                        <rect x="2" y="10.8" width="20" height="2.4" rx="1.2" />
                        <rect x="2" y="16.6" width="20" height="2.4" rx="1.2" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="logo-bg" />
          </div>
        </div>
      </div>

      {/* ===== Mobile / tablet off-canvas menu ===== */}
      <div
        id="cs-mobile-navigation"
        className={`th-menu-wrapper${mobileOpen ? ' th-menu-opened' : ''}`}
        aria-hidden={!mobileOpen}
        inert={!mobileOpen}
        onClick={(e) => {
          if (e.target === e.currentTarget) closeMobile()
        }}
      >
        <div className="th-menu-area">
          <button
            type="button"
            className="th-menu-toggle"
            aria-label="Close menu"
            onClick={closeMobile}
          >
            <svg
              className="icon-svg icon-svg-times"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M5.3 5.3a1 1 0 0 1 1.4 0L12 10.6l5.3-5.3a1 1 0 1 1 1.4 1.4L13.4 12l5.3 5.3a1 1 0 0 1-1.4 1.4L12 13.4l-5.3 5.3a1 1 0 0 1-1.4-1.4l5.3-5.3-5.3-5.3a1 1 0 0 1 0-1.4z" />
            </svg>
          </button>

          <div className="mobile-logo">
            <a href="/">
              <img alt="CollegeShine" width="150" height="36" decoding="async" src={LOGO_URL} />
            </a>
          </div>

          <div className="th-mobile-menu">
            <ul>
              {MENU_ITEMS.map((item, index) => (
                <li
                  key={item.label}
                  className={
                    item.children
                      ? `th-item-has-children${openSubmenu === index ? ' th-submenu-open' : ''}`
                      : undefined
                  }
                >
                  <a href={item.href} onClick={closeMobile}>
                    {item.label}
                  </a>
                  {item.children && (
                    <>
                      <button
                        type="button"
                        className="th-mobile-submenu-toggle"
                        aria-label={`${openSubmenu === index ? 'Hide' : 'Show'} ${item.label} submenu`}
                        aria-expanded={openSubmenu === index}
                        onClick={() => toggleMobileSubmenu(index)}
                      />
                      <ul className="sub-menu">
                        {item.children.map((child) => (
                          <li key={child.label}>
                            <a href={child.href} onClick={closeMobile}>
                              {child.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </header>
  )
}
